import styled from 'styled-components';
import EditSolid from '@simplywallst/ui-core/icons/EditSolid';

export const Wrapper = styled('section')`
  margin-bottom: ${({ theme }) => theme.x2spacePx}px;
  min-height: ${({ theme }) => theme.x4spacePx}px;
  position: relative;
  z-index: 1;
`;

export const AddNoteSVG = styled(EditSolid)`
  &&& {
    opacity: 1;
  }
`;
